import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface IframeMessage {
  type: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class IframeCommunicationService {
  private messageSubject = new Subject<IframeMessage>();
  public message$ = this.messageSubject.asObservable();

  constructor() {
    // Listen for postMessage from iframes
    window.addEventListener('message', (event: MessageEvent) => {
      // In production, validate event.origin for security
      // if (event.origin !== 'https://expected-origin.com') return;
      
      if (event.data && typeof event.data === 'object' && event.data.type) {
        this.messageSubject.next(event.data);
      }
    });
  }

  sendMessageToIframe(iframeWindow: Window, message: IframeMessage) {
    if (iframeWindow) {
      iframeWindow.postMessage(message, '*');
    }
  }
}
